// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3NUyq","content":"ManualTimeModal_content__349N2"};